import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function ReportFooter() {
  const { t } = useTranslation();
  const auth = useSelector((state) => state?.auth);
  const businessInfo = auth?.buisnessInfo || {};
  return (
    <div className="flex items-center justify-center border-t pt-4">
      <span className="font-semibold mr-2">{t("Address")}:</span>
      <span>{businessInfo?.address || t("N/A")}</span>
    </div>
  );
}

export default ReportFooter;
